"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[660],{

/***/ 10289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MB": function() { return /* binding */ fileDownloadHelper; },
/* harmony export */   "b5": function() { return /* binding */ pdfDownloadHelper; }
/* harmony export */ });
/* unused harmony export excelDownloadHelper */
/* harmony import */ var _pages_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44754);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11769);


// excel 파일 다운로드 반환 함수
var excelDownloadHelper = function(file) {
    var blob = new Blob([
        file.data
    ], {
        type: file.headers["content-type"],
        encoding: "UTF-8"
    });
    // 파일명 디코딩
    var name = decodeURI(file.headers["content-disposition"]);
    if (window.navigator.msSaveOrOpenBlob) {
        // IE 10+는 해당 함수 제공
        window.navigator.msSaveOrOpenBlob(blob);
    } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.target = "_self";
        if (name) link.download = name.split("=")[1];
        link.click();
        window.URL.revokeObjectURL(link); //메모리 누수 방지
    }
};
// pdf 파일 다운로드 반환 함수
var pdfDownloadHelper = function(file) {
    var blob = new Blob([
        file.data
    ], {
        type: file.headers["content-type"],
        encoding: "UTF-8"
    });
    // 파일명 디코딩
    var name = decodeURI(file.headers["content-disposition"]);
    // fileName = getFileName(name);
    if (window.navigator.msSaveOrOpenBlob) {
        // IE 10+는 해당 함수 제공
        window.navigator.msSaveOrOpenBlob(blob);
    } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.target = "_self";
        if (name) link.download = name.split('"')[1];
        link.click();
        window.URL.revokeObjectURL(link); //메모리 누수 방지
    }
};
// 파일 다운로드 반환 함수
var fileDownloadHelper = function(fileUrl) {
    var fileName = (0,_helper__WEBPACK_IMPORTED_MODULE_1__/* .getFileName */ .UO)(fileUrl);
    var a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileName;
    a.target = "_blank";
    a.click();
};


/***/ }),

/***/ 74547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60007);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: ",
        ";\n  z-index: 100000008;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .modal-section {\n    min-width: 40%;\n    background-color: white;\n    border-radius: 20px;\n    overflow: hidden;\n    @media (max-width: 991px) {\n      width: 60%;\n      overflow: auto;\n    }\n    @media (max-width: 767px) {\n      width: 90%;\n      overflow: auto;\n    }\n  }\n\n  .modal-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PostCodeModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44e38a55-0"
})(_templateObject(), function(props) {
    return props.isCheckout ? "" : "rgba(0, 0, 0, 0.8)";
});
var PostCode = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostCodeModal, {
            onClick: props === null || props === void 0 ? void 0 : props.onClickHandleModal,
            isCheckout: props.isCheckout,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "modal-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        style: {
                            height: "470px"
                        },
                        onComplete: props === null || props === void 0 ? void 0 : props.onCompletePostCode
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCode);


/***/ }),

/***/ 20660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ group_event_GroupEventLayout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./common/files.js
var files = __webpack_require__(10289);
// EXTERNAL MODULE: ./components/group-event/GroupEvent.styles.js
var GroupEvent_styles = __webpack_require__(11282);
// EXTERNAL MODULE: ./common/CustomFileInput.js
var CustomFileInput = __webpack_require__(62645);
;// CONCATENATED MODULE: ./components/group-event/types/typeTwo.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var TypeTwo = function(props) {
    var ref11, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var inputData = props.inputData, setInputData = props.setInputData, handleInputData = props.handleInputData, detailData = props.detailData, cancelInsert = props.cancelInsert, typeTwoUseForm = props.typeTwoUseForm;
    var register = typeTwoUseForm.register, handleSubmit = typeTwoUseForm.handleSubmit, errors = typeTwoUseForm.formState.errors, reset = typeTwoUseForm.reset, getValues = typeTwoUseForm.getValues, watch = typeTwoUseForm.watch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (detailData === null || detailData === void 0 ? void 0 : (ref11 = detailData.info) === null || ref11 === void 0 ? void 0 : ref11.id) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* InfoWrapper */.mo, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: "mb-10",
                    children: "\uC2E0\uCCAD \uC815\uBCF4"
                }),
                (detailData === null || detailData === void 0 ? void 0 : detailData.type) === "TYPE2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* InfoRow */.q$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\uD68C\uC0AC\uBA85"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: detailData === null || detailData === void 0 ? void 0 : (ref1 = detailData.info) === null || ref1 === void 0 ? void 0 : ref1.company
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* InfoRow */.q$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\uC2E0\uCCAD\uC790\uBA85"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: detailData === null || detailData === void 0 ? void 0 : (ref2 = detailData.info) === null || ref2 === void 0 ? void 0 : ref2.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* InfoRow */.q$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\uC5F0\uB77D\uCC98"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: detailData === null || detailData === void 0 ? void 0 : (ref3 = detailData.info) === null || ref3 === void 0 ? void 0 : ref3.phone
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* InfoRow */.q$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\uAD50\uC721 \uCC38\uC11D \uC778\uC6D0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        detailData === null || detailData === void 0 ? void 0 : (ref4 = detailData.info) === null || ref4 === void 0 ? void 0 : ref4.cnt,
                                        "\uBA85"
                                    ]
                                })
                            ]
                        }),
                        (detailData === null || detailData === void 0 ? void 0 : (ref5 = detailData.info) === null || ref5 === void 0 ? void 0 : ref5.stats) === "N" && /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* InfoRow */.q$, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "btn w-100",
                                onClick: function() {
                                    var ref;
                                    return cancelInsert(detailData === null || detailData === void 0 ? void 0 : (ref = detailData.info) === null || ref === void 0 ? void 0 : ref.id);
                                },
                                children: "\uC2E0\uCCAD \uCDE8\uC18C"
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "company",
                                className: "form-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: "\uD68C\uC0AC\uBA85"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                id: "company",
                                className: "form-input ".concat((errors === null || errors === void 0 ? void 0 : errors.company) && "border-danger"),
                                type: "text",
                                value: (inputData === null || inputData === void 0 ? void 0 : inputData.company) || ""
                            }, register("company", {
                                onChange: function(e) {
                                    return handleInputData(e, "company");
                                }
                            }))),
                            (errors === null || errors === void 0 ? void 0 : errors.company) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: (ref6 = errors.company) === null || ref6 === void 0 ? void 0 : ref6.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "name",
                                className: "form-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: "\uC2E0\uCCAD\uC790\uBA85"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                id: "name",
                                className: "form-input ".concat((errors === null || errors === void 0 ? void 0 : errors.name) && "border-danger"),
                                type: "text",
                                value: (inputData === null || inputData === void 0 ? void 0 : inputData.name) || ""
                            }, register("name", {
                                onChange: function(e) {
                                    return handleInputData(e, "name");
                                }
                            }))),
                            (errors === null || errors === void 0 ? void 0 : errors.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: (ref7 = errors.name) === null || ref7 === void 0 ? void 0 : ref7.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "phone",
                                className: "form-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: "\uC5F0\uB77D\uCC98"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                id: "phone",
                                className: "form-input ".concat((errors === null || errors === void 0 ? void 0 : errors.phone) && "border-danger"),
                                type: "text",
                                value: (inputData === null || inputData === void 0 ? void 0 : inputData.phone) || ""
                            }, register("phone", {
                                onChange: function(e) {
                                    return handleInputData(e, "phone");
                                }
                            }))),
                            (errors === null || errors === void 0 ? void 0 : errors.phone) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: (ref8 = errors.phone) === null || ref8 === void 0 ? void 0 : ref8.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "cnt",
                                className: "form-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: "\uAD50\uC721 \uCC38\uC11D \uC778\uC6D0"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                id: "cnt",
                                className: "form-input ".concat((errors === null || errors === void 0 ? void 0 : errors.phone) && "border-danger"),
                                type: "number",
                                min: "1",
                                value: (inputData === null || inputData === void 0 ? void 0 : inputData.cnt) || ""
                            }, register("cnt", {
                                onChange: function(e) {
                                    return handleInputData(e, "cnt");
                                }
                            }))),
                            (errors === null || errors === void 0 ? void 0 : errors.cnt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: (ref9 = errors.cnt) === null || ref9 === void 0 ? void 0 : ref9.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-fles flex-column mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "custome-checkbox d-flex align-items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                        type: "checkbox",
                                        id: "checkBox0",
                                        className: "form-check-input",
                                        style: {
                                            paddingTop: "2px"
                                        },
                                        checked: (inputData === null || inputData === void 0 ? void 0 : inputData.check) || ""
                                    }, register("check", {
                                        onChange: function(e) {
                                            return handleInputData(e, "check");
                                        }
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "checkBox0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "checkBox0",
                                        children: "(\uB3D9\uC758 \uD544\uC218) \uC81C\uCD9C\uD558\uC2E0 \uC815\uBCF4\uB85C \uC2E0\uCCAD\uC790\uAED8 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uC18C\uC2DD\uC744 \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4."
                                    })
                                ]
                            }),
                            (errors === null || errors === void 0 ? void 0 : errors.check) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: (ref10 = errors.check) === null || ref10 === void 0 ? void 0 : ref10.message
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var typeTwo = (TypeTwo);

// EXTERNAL MODULE: ./components/group-event/types/typeOne.styles.js
var typeOne_styles = __webpack_require__(88911);
// EXTERNAL MODULE: ./common/accordion/accordion.styles.js
var accordion_styles = __webpack_require__(74905);
;// CONCATENATED MODULE: ./common/accordion/accordion.js




var Accordion = function(props) {
    var data = props.data, open = props.open;
    var ref = (0,react.useState)(true), activeTab = ref[0], setActiveTab = ref[1];
    var handleActive = function() {
        setActiveTab(function(prev) {
            return !prev;
        });
    };
    (0,react.useEffect)(function() {
        if (open != undefined) {
            setActiveTab(open);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_styles/* AccordionBox */.Rk, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_styles/* AccordionHeader */._m, {
                    onClick: function() {
                        return handleActive(i);
                    },
                    active: activeTab,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_styles/* AccordionTitle */.il, {
                            children: data === null || data === void 0 ? void 0 : data.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: activeTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-angle-up"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-angle-down"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_styles/* AccordionBody */.X1, {
                    active: activeTab,
                    children: data === null || data === void 0 ? void 0 : data.content
                })
            ]
        })
    });
};
/* harmony default export */ var accordion = (Accordion);

// EXTERNAL MODULE: ./common/input/floatingInput.js
var floatingInput = __webpack_require__(44025);
;// CONCATENATED MODULE: ./components/group-event/types/typeOne.js
function typeOne_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function typeOne_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            typeOne_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var TypeOne = function(props) {
    var inputData = props.inputData, setInputData = props.setInputData, handleInputData = props.handleInputData, detailData = props.detailData, cancelInsert = props.cancelInsert, onClickHandleModal = props.onClickHandleModal, typeOneUseForm = props.typeOneUseForm, stickyBodyRef = props.stickyBodyRef;
    var fileRef = (0,react.useRef)(null);
    var register = typeOneUseForm.register, handleSubmit = typeOneUseForm.handleSubmit, errors = typeOneUseForm.formState.errors, reset = typeOneUseForm.reset, getValues = typeOneUseForm.getValues, watch = typeOneUseForm.watch;
    var ref = (0,react.useState)([]), activeTab = ref[0], setActiveTab = ref[1];
    var accordionData = [
        {
            title: "\uC8FC\uBB38 \uC218\uB7C9",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                    placeholder: "\uC8FC\uBB38 \uC218\uB7C9",
                    type: "number",
                    name: "cnt",
                    register: function(name) {
                        return typeOne_objectSpread({}, register(name, {
                            value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                            onChange: function(e) {
                                return handleInputData(e, name);
                            }
                        }));
                    },
                    value: (inputData === null || inputData === void 0 ? void 0 : inputData.cnt) || "",
                    error: errors === null || errors === void 0 ? void 0 : errors.cnt,
                    min: 500
                })
            })
        },
        {
            title: "\uC8FC\uBB38\uC790 \uC815\uBCF4",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uC5C5\uCCB4\uBA85",
                        name: "company",
                        register: function(name) {
                            return typeOne_objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.company) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uB2F4\uB2F9\uC790",
                        name: "name",
                        register: function(name) {
                            return typeOne_objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.name) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uB2F4\uB2F9\uC790 \uC5F0\uB77D\uCC98",
                        name: "phone",
                        register: function(name) {
                            return typeOne_objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.phone) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.phone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uB2F4\uB2F9\uC790 \uC774\uBA54\uC77C",
                        name: "email",
                        register: function(name) {
                            return typeOne_objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.email) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.email
                    })
                ]
            })
        },
        {
            title: "\uBC30\uC1A1\uC9C0 \uC815\uBCF4",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-group mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                            placeholder: "\uC8FC\uC18C",
                            name: "doro_addr",
                            register: function(name) {
                                return typeOne_objectSpread({}, register(name, {
                                    value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                    onChange: function(e) {
                                        return handleInputData(e, name);
                                    }
                                }));
                            },
                            value: (inputData === null || inputData === void 0 ? void 0 : inputData.doro_addr) || (inputData === null || inputData === void 0 ? void 0 : inputData.base_addr) || "",
                            readOnly: true,
                            onClick: onClickHandleModal,
                            error: errors === null || errors === void 0 ? void 0 : errors.doro_addr
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                            placeholder: "\uC0C1\uC138 \uC8FC\uC18C",
                            name: "detail_addr",
                            value: (inputData === null || inputData === void 0 ? void 0 : inputData.detail_addr) || "",
                            register: function(name) {
                                return typeOne_objectSpread({}, register(name, {
                                    value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                    onChange: function(e) {
                                        return handleInputData(e, name);
                                    }
                                }));
                            },
                            error: errors === null || errors === void 0 ? void 0 : errors.detail_addr
                        })
                    ]
                })
            })
        },
        {
            title: "\uCD94\uAC00 \uC815\uBCF4",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-group mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex align-items-center justify-content-between mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: "",
                                            children: "\uD30C\uC77C \uC5C5\uB85C\uB4DC"
                                        }),
                                        (detailData === null || detailData === void 0 ? void 0 : detailData.file) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "button",
                                            className: "btn btn-xs",
                                            target: "__blank",
                                            href: detailData.file,
                                            children: "\uCE7C\uC120 \uB2E4\uC6B4\uB85C\uB4DC"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: fileRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFileInput/* default */.Z, {
                                        handleFiles: function(files) {
                                            setInputData(typeOne_objectSpread({}, inputData, {
                                                file: files[0]
                                            }));
                                        },
                                        reset: function(files) {
                                            return reset(typeOne_objectSpread({}, getValues(), {
                                                file: files[0]
                                            }));
                                        },
                                        error: errors === null || errors === void 0 ? void 0 : errors.file,
                                        name: "files",
                                        max: 1
                                    })
                                }),
                                (errors === null || errors === void 0 ? void 0 : errors.file) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mt-1 text-danger",
                                    children: errors === null || errors === void 0 ? void 0 : errors.file.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mt-3",
                                    children: "* \uB85C\uACE0\uD30C\uC77C \uB610\uB294 \uB85C\uACE0\uAC00 \uBC30\uCE58\uB41C \uCE7C\uC120\uB3C4\uC548\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694 (ai \uD30C\uC77C)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "* \uB85C\uACE0\uAC00 \uC900\uBE44\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC740 \uACBD\uC6B0\uC5D0\uB294 \uAD00\uB828 \uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694 (\uD30C\uC77C \uD615\uC2DD \uBB34\uAD00)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-3 d-flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: "mb-3",
                                    children: "\uB514\uC790\uC778 \uC791\uC5C5 \uC120\uD0DD"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", typeOne_objectSpread({
                                    className: "form-select ".concat(errors.editYn && "border-danger shadow-none"),
                                    name: "editYn",
                                    value: (inputData === null || inputData === void 0 ? void 0 : inputData.editYn) || ""
                                }, register("editYn", {
                                    value: inputData === null || inputData === void 0 ? void 0 : inputData.editYn,
                                    onChange: function(e) {
                                        return handleInputData(e, "editYn");
                                    }
                                }), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "",
                                            disabled: true,
                                            children: "\uB514\uC790\uC778 \uC791\uC5C5 \uC120\uD0DD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "TYPE0",
                                            children: "\uC120\uD0DD \uC548\uD568"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "TYPE1",
                                            children: "\uB3C4\uC548 \uCE7C\uC120\uBC30\uCE58"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "TYPE2",
                                            children: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4(\uBCC4\uB3C4 \uBE44\uC6A9 \uC0C1\uB2F4)"
                                        })
                                    ]
                                })),
                                (errors === null || errors === void 0 ? void 0 : errors.editYn) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mt-1 text-danger",
                                    children: errors === null || errors === void 0 ? void 0 : errors.editYn.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mt-3",
                                    children: "* \uB85C\uACE0\uD30C\uC77C\uC774 \uC788\uC9C0\uB9CC \uC77C\uB7EC\uC2A4\uD2B8 \uC791\uC5C5\uC774 \uC5B4\uB824\uC6B0\uC2E0 \uCE7C\uC120\uB3C4\uC548 \uBC30\uCE58\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "* \uB85C\uACE0\uD30C\uC77C\uC774 \uC5C6\uB294 \uACBD\uC6B0",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/customizing/design-service/",
                                            target: "__blank",
                                            children: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4"
                                        }),
                                        "\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", typeOne_objectSpread({
                                    placeholder: "\uC694\uCCAD\uC0AC\uD56D",
                                    className: "mt-3",
                                    name: "memo",
                                    value: (inputData === null || inputData === void 0 ? void 0 : inputData.memo) || ""
                                }, register("memo", {
                                    value: inputData === null || inputData === void 0 ? void 0 : inputData.memo,
                                    onChange: function(e) {
                                        return handleInputData(e, "memo");
                                    }
                                })))
                            ]
                        })
                    ]
                })
            })
        }, 
    ];
    (0,react.useEffect)(function() {
        if (Object.keys(errors).length > 0) {
            var tempArr = new Array(accordionData.length).fill(true);
            setActiveTab(tempArr);
            if (Object.keys(errors).length === 1 && errors.file) {
                stickyBodyRef.current.scrollTo({
                    behavior: "instant",
                    left: 0,
                    top: fileRef.current.offsetTop - 130
                });
            }
        }
    }, [
        errors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typeOne_styles/* TypeOneSection */.h, {
            children: (accordionData === null || accordionData === void 0 ? void 0 : accordionData.length) > 0 && accordionData.map(function(el, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion, {
                    data: el,
                    open: activeTab[i]
                }, i);
            })
        })
    });
};
/* harmony default export */ var typeOne = (TypeOne);

;// CONCATENATED MODULE: ./common/CountdownTimer.js


var CountdownTimer = function(param) {
    var targetDate = param.targetDate;
    var calculateTimeLeft = function() {
        var now = new Date();
        var difference = new Date(targetDate) - now;
        var timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                일: Math.floor(difference / (1000 * 60 * 60 * 24)),
                시간: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
                분: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
                초: Math.floor(difference % (1000 * 60) / 1000)
            };
        }
        return timeLeft;
    };
    var ref = (0,react.useState)(calculateTimeLeft()), timeLeft1 = ref[0], setTimeLeft = ref[1];
    (0,react.useEffect)(function() {
        var timer = setInterval(function() {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return function() {
            return clearInterval(timer);
        };
    }, [
        targetDate
    ]);
    var timerComponents = [];
    Object.keys(timeLeft1).forEach(function(interval) {
        if (interval !== "\uCD08" && !timeLeft1[interval]) {
            return;
        }
        timerComponents.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                timeLeft1[interval],
                interval,
                " "
            ]
        }, interval));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: timerComponents.length ? timerComponents : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
    });
};
/* harmony default export */ var common_CountdownTimer = (CountdownTimer);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/cart/cart-styles.js
var cart_styles = __webpack_require__(67503);
;// CONCATENATED MODULE: ./components/group-event/GroupEvent.js












var GroupEventUI = function(props) {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var detailData = props.detailData, scroll = props.scroll, subChild = props.subChild, inputData = props.inputData, setInputData = props.setInputData, handleInputData = props.handleInputData, confirmInsert = props.confirmInsert, userInfo = props.userInfo, cancelInsert = props.cancelInsert, onClickHandleModal = props.onClickHandleModal, typeOneUseForm = props.typeOneUseForm, typeTwoUseForm = props.typeTwoUseForm, eventOpen = props.eventOpen;
    var stickyBodyRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* Container */.W2, {
            className: "container",
            children: eventOpen === "none" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* EmptyWrapper */.zD, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://image.caretbio.com/store/webhard/\u110C\u1175\u110F\u1161\u11AF\u1105\u1166\u11BA_\u1110\u1161\u11AB\u1109\u1169_420x200.png",
                        alt: "empty-edu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "title",
                        children: "\uD604\uC7AC \uC2E0\uCCAD\uAC00\uB2A5\uD55C \uAD50\uC721\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/esg-guide/letter",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "btn",
                                children: "ESG \uB274\uC2A4\uB808\uD130 \uBCF4\uB7EC\uAC00\uAE30"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* DetailWrapper */.c0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* DetailSection */.Kk, {
                        className: "single-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: detailData === null || detailData === void 0 ? void 0 : detailData.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: detailData === null || detailData === void 0 ? void 0 : detailData.content
                                },
                                className: "ck-content"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* StickySection */.hI, {
                        $scroll: scroll,
                        onSubmit: (detailData === null || detailData === void 0 ? void 0 : detailData.type) === "TYPE1" && typeOneUseForm.handleSubmit(confirmInsert, function(errors) {
                            if (errors) {
                                (0,common_alert/* failAlert */.qh)(Object.values(errors)[0].message);
                            }
                        }) || (detailData === null || detailData === void 0 ? void 0 : detailData.type) === "TYPE2" && typeTwoUseForm.handleSubmit(confirmInsert, function(errors) {
                            if (errors) {
                                (0,common_alert/* failAlert */.qh)(Object.values(errors)[0].message);
                            }
                        }) || confirmInsert,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* StickyHeader */.M5, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            subChild,
                                            " \uC2E0\uCCAD"
                                        ]
                                    }),
                                    eventOpen === "proceeding" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                        className: "d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "me-1",
                                                children: "\uC885\uB8CC\uAE4C\uC9C0 "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-alarm-clock"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CountdownTimer, {
                                                targetDate: new Date(detailData === null || detailData === void 0 ? void 0 : detailData.edate)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ms-1",
                                                children: "\uB0A8\uC558\uC2B5\uB2C8\uB2E4."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* StickyBody */.ed, {
                                ref: stickyBodyRef,
                                children: (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: eventOpen === "loading" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-100 d-flex align-items-center justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            role: "status"
                                        })
                                    }) || eventOpen === "proceeding" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            (detailData === null || detailData === void 0 ? void 0 : detailData.type) === "TYPE1" && /*#__PURE__*/ (0,jsx_runtime.jsx)(typeOne, {
                                                detailData: detailData,
                                                inputData: inputData,
                                                setInputData: setInputData,
                                                handleInputData: handleInputData,
                                                cancelInsert: cancelInsert,
                                                onClickHandleModal: onClickHandleModal,
                                                typeOneUseForm: typeOneUseForm,
                                                stickyBodyRef: stickyBodyRef
                                            }),
                                            (detailData === null || detailData === void 0 ? void 0 : detailData.type) === "TYPE2" && /*#__PURE__*/ (0,jsx_runtime.jsx)(typeTwo, {
                                                detailData: detailData,
                                                inputData: inputData,
                                                setInputData: setInputData,
                                                handleInputData: handleInputData,
                                                cancelInsert: cancelInsert,
                                                typeTwoUseForm: typeTwoUseForm
                                            })
                                        ]
                                    }) || eventOpen === "before" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* TimerWrapper */.vb, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "\uACF5\uB3D9 \uAD6C\uB9E4 \uC2E0\uCCAD \uC624\uD508\uAE4C\uC9C0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "d-flex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CountdownTimer, {
                                                        targetDate: new Date(detailData === null || detailData === void 0 ? void 0 : detailData.sdate)
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ms-1",
                                                        children: "\uB0A8\uC558\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        ]
                                    }) || eventOpen === "after" && /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* TimerWrapper */.vb, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                            children: [
                                                "\uB9C8\uAC10\uB41C ",
                                                subChild,
                                                "\uC785\uB2C8\uB2E4."
                                            ]
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* GuestWrapper */.Fi, {
                                    children: eventOpen === "loading" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-100 d-flex align-items-center justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            role: "status"
                                        })
                                    }) || /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/login",
                                                children: "\uB85C\uADF8\uC778"
                                            }),
                                            " \uD6C4 \uC774\uC6A9\uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* StickyFooter */.oW, {
                                children: router.pathname.includes("edu") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "btn confirm",
                                    disabled: detailData === null || detailData === void 0 ? void 0 : (ref1 = detailData.info) === null || ref1 === void 0 ? void 0 : ref1.id,
                                    children: (detailData === null || detailData === void 0 ? void 0 : (ref2 = detailData.info) === null || ref2 === void 0 ? void 0 : ref2.id) ? "\uC2E0\uCCAD\uC644\uB8CC" : "\uC2E0\uCCAD\uD558\uAE30"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "btn confirm",
                                    disabled: eventOpen !== "proceeding",
                                    children: eventOpen === "loading" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex align-items-center justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            role: "status",
                                            className: "spinner-border-sm"
                                        })
                                    }) || eventOpen === "proceeding" && "\uC2E0\uCCAD\uD558\uAE30" || eventOpen === "before" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex align-items-center justify-content-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CountdownTimer, {
                                                targetDate: new Date(detailData === null || detailData === void 0 ? void 0 : detailData.sdate)
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ms-2",
                                                children: "\uD6C4 \uC624\uD508"
                                            })
                                        ]
                                    }) || eventOpen === "after" && "\uC2E0\uCCAD \uB9C8\uAC10"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var GroupEvent = (GroupEventUI);

// EXTERNAL MODULE: ./api/apis.js
var apis = __webpack_require__(66887);
// EXTERNAL MODULE: ./common/postcode.js
var postcode = __webpack_require__(74547);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./common/validation.js
var validation = __webpack_require__(10103);
// EXTERNAL MODULE: ./common/util/getDate.js
var getDate = __webpack_require__(69644);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./components/group-event/GroupEventLayout.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function GroupEventLayout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GroupEventLayout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GroupEventLayout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















var GroupEventLayout = function(props) {
    var _$isLoading = props.isLoading, _$isLoaded = props.isLoaded, _$openConfirmModal = props.openConfirmModal, _$modifyConfirmModal = props.modifyConfirmModal, _$closeConfirmModal = props.closeConfirmModal, parent = props.parent, sub = props.sub, subChild = props.subChild, code1 = props.code, userInfo = props.userInfo;
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)(false), postCodeOpen = ref7[0], setPostCodeOpen = ref7[1];
    var ref1 = (0,react.useState)(null), detailData = ref1[0], setDetailData = ref1[1];
    var ref2 = (0,react.useState)(false), scroll = ref2[0], setScroll = ref2[1];
    var ref3 = (0,react.useState)({
        check: false
    }), inputData = ref3[0], setInputData = ref3[1];
    var typeOneOptions = {
        resolver: (0,yup/* yupResolver */.X)((0,validation/* GPTypeOneSchema */.lI)({
            min: detailData === null || detailData === void 0 ? void 0 : detailData.min,
            rounding: detailData === null || detailData === void 0 ? void 0 : detailData.rounding,
            max: detailData === null || detailData === void 0 ? void 0 : detailData.max
        })),
        mode: "onChange"
    };
    var typeTwoOptions = {
        resolver: (0,yup/* yupResolver */.X)(validation/* GPTypeTwoSchema */.JW),
        mode: "onChange"
    };
    var typeOneUseForm = (0,index_esm/* useForm */.cI)(typeOneOptions);
    var typeTwoUseForm = (0,index_esm/* useForm */.cI)(typeTwoOptions);
    var fetchUserInfo = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref5, ref6, member, address, eduDefault, groupDefault, userInfoDefault, tempObj;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!userInfo) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            ;
                            member = userInfo === null || userInfo === void 0 ? void 0 : userInfo.Member;
                            address = userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Address) === null || ref === void 0 ? void 0 : ref.data.find(function(el) {
                                return el.basic === "Y";
                            });
                            eduDefault = {
                                cnt: 1
                            };
                            groupDefault = {
                                cnt: 500,
                                memo: "",
                                editYn: ""
                            };
                            userInfoDefault = GroupEventLayout_objectSpread({
                                name: (member === null || member === void 0 ? void 0 : member.name) || "",
                                phone: (member === null || member === void 0 ? void 0 : member.phone) || "",
                                company: (userInfo === null || userInfo === void 0 ? void 0 : (ref5 = userInfo.Company) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.Data) === null || ref6 === void 0 ? void 0 : ref6.name) || "",
                                email: (member === null || member === void 0 ? void 0 : member.email) || ""
                            }, address);
                            tempObj = {};
                            if (router.pathname.includes("edu")) {
                                tempObj = GroupEventLayout_objectSpread({}, eduDefault, userInfoDefault);
                            }
                            if (router.pathname.includes("group-purchase")) {
                                tempObj = GroupEventLayout_objectSpread({}, groupDefault, userInfoDefault);
                                typeOneUseForm.reset(GroupEventLayout_objectSpread({}, typeOneUseForm.getValues(), groupDefault, userInfoDefault));
                            }
                            setInputData(GroupEventLayout_objectSpread({}, inputData, tempObj));
                        }
                        _ctx.next = 5;
                        break;
                    case 4:
                        return _ctx.abrupt("return");
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchUserInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputData = function(e, key) {
        if (key === "check") {
            setInputData(GroupEventLayout_objectSpread({}, inputData, GroupEventLayout_defineProperty({}, key, e.target.checked)));
            return;
        }
        setInputData(GroupEventLayout_objectSpread({}, inputData, GroupEventLayout_defineProperty({}, key, e.target.value)));
    };
    var fetchDetail = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(code) {
            var body, res, ref, ref8, ref9;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _$isLoading();
                        body = {
                            modes: "ViewSet",
                            code: code
                        };
                        _ctx.next = 4;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 4:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            ;
                            setDetailData(GroupEventLayout_objectSpread({}, (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Row, {
                                info: res === null || res === void 0 ? void 0 : (ref8 = res.Data) === null || ref8 === void 0 ? void 0 : ref8.Info
                            }));
                        } else {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref9 = res.Data) === null || ref9 === void 0 ? void 0 : ref9.Msg) || "\uC870\uD68C \uC2E4\uD328");
                        }
                        _$isLoaded();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchDetail(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var confirmInsert = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var body, res, ref, ref10;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (userInfo) {
                            _ctx.next = 4;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uB85C\uADF8\uC778 \uD6C4 \uC774\uC6A9\uAC00\uB2A5\uD55C \uC11C\uBE44\uC2A4 \uC785\uB2C8\uB2E4.");
                        router.push("/login");
                        return _ctx.abrupt("return");
                    case 4:
                        _$isLoading();
                        body = GroupEventLayout_objectSpread({
                            modes: "InsertSet",
                            code: code1
                        }, data);
                        _ctx.next = 8;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 8:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            if (detailData.type === "TYPE1") {
                                router.push("/mypage/group-purchase/");
                            }
                        } else if (res.Code === "8888") {} else {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref10 = res.Data) === null || ref10 === void 0 ? void 0 : ref10.Msg) || "\uB4F1\uB85D \uC2E4\uD328");
                        }
                        fetchDetail(code1);
                        _$isLoaded();
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function confirmInsert(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelInsert = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee1(id) {
            var content;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        content = {
                            title: "\uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                            actionBtnLabel: "\uD655\uC778",
                            actionBtnValid: true,
                            cancelBtnLabel: "\uCDE8\uC18C",
                            onClose: function() {},
                            onAction: _asyncToGenerator(runtime_default().mark(function _callee() {
                                var body, res, ref, ref11;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _$isLoading();
                                            body = {
                                                modes: "CancelSet",
                                                id: id
                                            };
                                            _ctx.next = 4;
                                            return (0,apis/* EventPagesAPI */.SM)(body);
                                        case 4:
                                            res = _ctx.sent;
                                            if (res.Code === "0000") {
                                                ;
                                                (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uCDE8\uC18C \uC644\uB8CC");
                                                fetchDetail(code1);
                                            } else {
                                                ;
                                                (0,common_alert/* failAlert */.qh)(((ref11 = res.Data) === null || ref11 === void 0 ? void 0 : ref11.Msg) || "\uCDE8\uC18C \uC2E4\uD328");
                                                fetchDetail(code1);
                                            }
                                            _$closeConfirmModal();
                                            _$isLoaded();
                                        case 8:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        };
                        _$modifyConfirmModal(content);
                        _$openConfirmModal();
                    case 3:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function cancelInsert(id) {
            return _ref.apply(this, arguments);
        };
    }();
    // 우편번호 검색
    var onClickHandleModal = function() {
        setPostCodeOpen(function(prev) {
            return !prev;
        });
    };
    var onCompletePostCode = function(postcode) {
        setInputData(GroupEventLayout_objectSpread({}, inputData, {
            doro_addr: postcode.roadAddress !== "" ? postcode.roadAddress : postcode.autoRoadAddress,
            base_addr: postcode.jibunAddress !== "" ? postcode.jibunAddress : postcode.autoJibunAddress,
            zipcode: postcode.zonecode
        }));
        if ((detailData === null || detailData === void 0 ? void 0 : detailData.type) === "TYPE1") {
            typeOneUseForm.reset(GroupEventLayout_objectSpread({}, typeOneUseForm.getValues(), {
                doro_addr: postcode.roadAddress !== "" ? postcode.roadAddress : postcode.autoRoadAddress,
                base_addr: postcode.jibunAddress !== "" ? postcode.jibunAddress : postcode.autoJibunAddress,
                zipcode: postcode.zonecode
            }));
        }
        setPostCodeOpen(false);
    };
    // check open
    var checkOpen = function() {
        if (!(detailData === null || detailData === void 0 ? void 0 : detailData.sdate)) {
            return "loading";
        }
        if ((0,getDate/* getTimeStamp */.dg)() < new Date(detailData === null || detailData === void 0 ? void 0 : detailData.sdate).getTime()) {
            return "before";
        } else if ((0,getDate/* getTimeStamp */.dg)() > new Date(detailData === null || detailData === void 0 ? void 0 : detailData.edate).getTime()) {
            return "after";
        } else {
            return "proceeding";
        }
    };
    var ref4 = (0,react.useState)(checkOpen()), eventOpen = ref4[0], setEventOpen = ref4[1];
    (0,react.useEffect)(function() {
        if (detailData === null || detailData === void 0 ? void 0 : detailData.sdate) {
            var timer = setInterval(function() {
                setEventOpen(checkOpen());
            }, 1000);
            return function() {
                return clearInterval(timer);
            };
        }
    }, [
        detailData
    ]);
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if (code1 === null) setEventOpen("none");
        if (userInfo) fetchUserInfo();
        fetchDetail(code1);
    }, [
        router.isReady,
        userInfo,
        code1
    ]);
    (0,react.useEffect)(function() {
        var scrollControl = function() {
            var scrollCheck = window.scrollY >= 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        };
        document.addEventListener("scroll", scrollControl);
        return function() {
            document.removeEventListener("scroll", scrollControl);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            parent: parent || "\uD648",
            sub: "\uACF5\uB3D9\uAD6C\uB9E4",
            pageTitle: SeoMeta/* SeoMeta.groupPurchase.title */.e.groupPurchase.title,
            pageDesc: SeoMeta/* SeoMeta.groupPurchase.description */.e.groupPurchase.description,
            pageKeyword: SeoMeta/* SeoMeta.groupPurchase.keywords */.e.groupPurchase.keywords,
            children: [
                code1 !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent, {
                    detailData: detailData,
                    scroll: scroll,
                    subChild: subChild,
                    inputData: inputData,
                    setInputData: setInputData,
                    handleInputData: handleInputData,
                    confirmInsert: confirmInsert,
                    userInfo: userInfo,
                    cancelInsert: cancelInsert,
                    onClickHandleModal: onClickHandleModal,
                    typeOneUseForm: typeOneUseForm,
                    typeTwoUseForm: typeTwoUseForm,
                    eventOpen: eventOpen
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "350px"
                    }
                }),
                postCodeOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(postcode/* default */.Z, {
                    onClickHandleModal: onClickHandleModal,
                    onCompletePostCode: onCompletePostCode
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        userInfo: state.userInfo
    };
};
var mapDispatchToProps = {
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k,
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6
};
/* harmony default export */ var group_event_GroupEventLayout = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(GroupEventLayout));


/***/ }),

/***/ 90651:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=_interopRequireWildcard(__webpack_require__(67294)),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["scriptUrl","className","style","defaultQuery","autoClose","errorMessage","onComplete","onClose","onResize","onSearch"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function _defineProperties(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,"value"in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}function _createClass(a,b,c){return b&&_defineProperties(a.prototype,b),c&&_defineProperties(a,c),a}function _inherits(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function");a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,writable:!0,configurable:!0}}),b&&_setPrototypeOf(a,b)}function _setPrototypeOf(a,b){return _setPrototypeOf=Object.setPrototypeOf||function(a,b){return a.__proto__=b,a},_setPrototypeOf(a,b)}function _createSuper(a){var b=_isNativeReflectConstruct();return function(){var c,d=_getPrototypeOf(a);if(b){var e=_getPrototypeOf(this).constructor;c=Reflect.construct(d,arguments,e)}else c=d.apply(this,arguments);return _possibleConstructorReturn(this,c)}}function _possibleConstructorReturn(a,b){return b&&("object"===_typeof(b)||"function"==typeof b)?b:_assertThisInitialized(a)}function _assertThisInitialized(a){if(void 0===a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return a}function _isNativeReflectConstruct(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(a){return!1}}function _getPrototypeOf(a){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(a){return a.__proto__||Object.getPrototypeOf(a)},_getPrototypeOf(a)}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}var defaultErrorMessage=/*#__PURE__*/_react.default.createElement("p",null,"\uD604\uC7AC Daum \uC6B0\uD3B8\uBC88\uD638 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."),defaultStyle={width:"100%",height:400},defaultProps={scriptUrl:_loadPostcode.postcodeScriptUrl,errorMessage:defaultErrorMessage,autoClose:!0},DaumPostcodeEmbed=/*#__PURE__*/function(a){function b(){var a;_classCallCheck(this,b);for(var d=arguments.length,e=Array(d),f=0;f<d;f++)e[f]=arguments[f];return a=c.call.apply(c,[this].concat(e)),_defineProperty(_assertThisInitialized(a),"mounted",!1),_defineProperty(_assertThisInitialized(a),"wrap",/*#__PURE__*/(0,_react.createRef)()),_defineProperty(_assertThisInitialized(a),"state",{hasError:!1}),_defineProperty(_assertThisInitialized(a),"initiate",function(b){if(a.wrap.current){var c=a.props,d=c.scriptUrl,e=c.className,f=c.style,g=c.defaultQuery,h=c.autoClose,i=c.errorMessage,j=c.onComplete,k=c.onClose,l=c.onResize,m=c.onSearch,n=_objectWithoutProperties(c,_excluded),o=new b(_objectSpread(_objectSpread({},n),{},{oncomplete:function oncomplete(b){j&&j(b),h&&a.wrap.current&&a.wrap.current.remove()},onsearch:m,onresize:l,onclose:k,width:"100%",height:"100%"}));o.embed(a.wrap.current,{q:g,autoClose:h})}}),_defineProperty(_assertThisInitialized(a),"onError",function(b){console.error(b),a.setState({hasError:!0})}),a}_inherits(b,a);var c=_createSuper(b);return _createClass(b,[{key:"componentDidMount",value:function componentDidMount(){var a=this.initiate,b=this.onError,c=this.props.scriptUrl;c&&(this.mounted||((0,_loadPostcode.default)(c).then(a).catch(b),this.mounted=!0))}},{key:"render",value:function render(){var a=this.props,b=a.className,c=a.style,d=a.errorMessage,e=this.state.hasError;return/*#__PURE__*/_react.default.createElement("div",{ref:this.wrap,className:b,style:_objectSpread(_objectSpread({},defaultStyle),c)},e&&d)}}]),b}(_react.Component);_defineProperty(DaumPostcodeEmbed,"defaultProps",defaultProps);var _default=DaumPostcodeEmbed;exports["default"]=_default;

/***/ }),

/***/ 60007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _DaumPostcodeEmbed.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _useDaumPostcodePopup.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _loadPostcode.default}}),exports.ZP=void 0;var _DaumPostcodeEmbed=_interopRequireDefault(__webpack_require__(90651)),_useDaumPostcodePopup=_interopRequireDefault(__webpack_require__(339)),_loadPostcode=_interopRequireDefault(__webpack_require__(52171));function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var _default=_DaumPostcodeEmbed.default;exports.ZP=_default;

/***/ }),

/***/ 52171:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=exports.postcodeScriptUrl=void 0;var postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";exports.postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";var loadPostcode=function(){var a=null;return function(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:postcodeScriptUrl;return a?a:(a=new Promise(function(a,c){var d=document.createElement("script");d.src=b,d.onload=function(){var b,d;return null!==(b=window)&&void 0!==b&&null!==(d=b.daum)&&void 0!==d&&d.Postcode?a(window.daum.Postcode):void c(new Error("Script is loaded successfully, but cannot find Postcode module. Check your scriptURL property."))},d.onerror=function(a){return c(a)},d.id="daum_postcode_script",document.body.appendChild(d)}),a)}}(),_default=loadPostcode;exports["default"]=_default;

/***/ }),

/***/ 339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=__webpack_require__(67294),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["defaultQuery","left","top","popupKey","popupTitle","autoClose","onComplete","onResize","onClose","onSearch","onError"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function useDaumPostcodePopup(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:_loadPostcode.postcodeScriptUrl;(0,_react.useEffect)(function(){(0,_loadPostcode.default)(a)},[a]);var b=(0,_react.useCallback)(function(b){var c=_objectSpread({},b),d=c.defaultQuery,e=c.left,f=c.top,g=c.popupKey,h=c.popupTitle,i=c.autoClose,j=c.onComplete,k=c.onResize,l=c.onClose,m=c.onSearch,n=c.onError,o=_objectWithoutProperties(c,_excluded);return(0,_loadPostcode.default)(a).then(function(a){var b=new a(_objectSpread(_objectSpread({},o),{},{oncomplete:j,onsearch:m,onresize:k,onclose:l}));b.open({q:d,left:e,top:f,popupTitle:h,popupKey:g,autoClose:i})}).catch(n)},[a]);return b}var _default=useDaumPostcodePopup;exports["default"]=_default;

/***/ })

}]);